import React from 'react';
import { capitalize, sortBy } from 'lodash';
// Api
import {
  GetCampaignsV2_getCampaigns_entities_activities_UgcActivity,
  GetCampaignsV2_getCampaigns_entities_activities_UgcActivity_tasks_CampaignContentTask,
} from 'api/campaignV2/types/GetCampaignsV2';
// Helpers
import { getContentDueDateLabel } from 'helpers/timelineDeliverables';
// Styles
import styles from '../CampaignActivityData.module.scss';

type UgcActivityProps = {
  UgcActivity: GetCampaignsV2_getCampaigns_entities_activities_UgcActivity;
};

const UgcActivity = ({
  UgcActivity,
}: Partial<UgcActivityProps>): JSX.Element => {
  return (
    <>
      {!!UgcActivity?.tasks?.length && (
        <div>
          <p className={styles.label}>Timeline Deliverables</p>
          {sortBy(UgcActivity?.tasks, 'orderIdx').map((task, index) => {
            return (
              <div
                key={task.id || task.title + '-' + index}
                className={styles.deliverableContainer}
              >
                <p className={styles.label}>
                  {`Content ${index + 1}:`} {task.title}
                </p>

                <div className={styles.deliverableDetails}>
                  <p className={styles.value}>
                    <strong>Media Type:</strong>{' '}
                    {capitalize(
                      (
                        task as GetCampaignsV2_getCampaigns_entities_activities_UgcActivity_tasks_CampaignContentTask
                      ).mediaType ?? ''
                    )}
                  </p>

                  {task.description && (
                    <p className={styles.value}>
                      <strong>Description:</strong> {task.description}
                    </p>
                  )}

                  <p className={styles.value}>
                    <strong>Content Due Date:</strong>{' '}
                    {getContentDueDateLabel(task)}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </>
  );
};

export default UgcActivity;
